import React, { useEffect, useState } from "react";
import {
  Container,
  Typography,
  Paper,
  Grid,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import axios from "axios";
import { API_BASE_URL, SessionManager } from "../utils/consts";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import { CopyToClipboard } from "react-copy-to-clipboard";

import LocationOnIcon from "@mui/icons-material/LocationOn";

interface User {
  id: number;
  name: string;
  email: string;
  phone_number: string;
  address: string;
  user_type: string;
  company_name: string;
  location: string;
}

interface Users {
  users: User[];
}

interface UserManagementProps {
  sessionManager: SessionManager;
}

const UserManagement: React.FC<UserManagementProps> = ({ sessionManager }) => {
  const [users, setUsers] = useState<Users>({ users: [] });
  const [userToUpdate, setUserToUpdate] = useState<User | null>(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedUserType, setSelectedUserType] = useState<string>("default");
  const [userToShowLocation, setUserToShowLocation] = useState<User | null>(
    null
  );
  const [openLocationDialog, setOpenLocationDialog] = useState(false);

  const getUsers = async () => {
    const responseData = await sessionManager.getData("all_users");
    setUsers(responseData);
  };

  useEffect(() => {
    getUsers();
  }, []);

  function updateUser(user: User) {
    setUserToUpdate(user);
  }

  const handleOpenDialog = (user: User) => {
    setUserToUpdate(user);
    setSelectedUserType(user.user_type);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setUserToUpdate(null);
  };

  const handleCloseLocationDialog = () => {
    setOpenLocationDialog(false);
    setUserToShowLocation(null);
  };

  const handleUserTypeChange = (event: SelectChangeEvent) => {
    setSelectedUserType(event.target.value as string);
  };

  const handleSaveUserType = async () => {
    if (userToUpdate) {
      try {
        const token = sessionManager.getToken();
        await axios.post(
          `${API_BASE_URL}/update_user_type`,
          {
            user_id: userToUpdate.id,
            user_type: selectedUserType,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        console.log("updating...");
        console.log(selectedUserType);
        console.log(userToUpdate);
        getUsers(); // Refresh the user list
        handleCloseDialog();
      } catch (error) {
        if (axios.isAxiosError(error)) {
          console.error(
            "Error updating user type:",
            error.response?.data || error.message
          );
          sessionManager.signOut();
        } else {
          console.error("Unexpected error:", error);
        }
      }
    }
  };

  const handleShowLocation = (user: User) => {
    console.log(user.location);
    setUserToShowLocation(user);
    setOpenLocationDialog(true);
  };

  return (
    <Container style={{ marginTop: "20px" }}>
      <Typography variant="h4" gutterBottom>
        User Management
      </Typography>
      <TableContainer component={Paper}>
        <Table>
          <TableHead style={{ backgroundColor: "#D3D3D3" }}>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Email</TableCell>
              <TableCell>Phone</TableCell>
              <TableCell>Company</TableCell>
              <TableCell>Type</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {users.users.map((user) => (
              <TableRow key={user.id}>
                <TableCell>{user.name}</TableCell>
                <TableCell>{user.email}</TableCell>
                <TableCell>{user.phone_number}</TableCell>
                <TableCell>{user.company_name}</TableCell>
                <TableCell>{user.user_type}</TableCell>
                <TableCell>
                  <Button onClick={() => handleOpenDialog(user)}>Update</Button>
                  <CopyToClipboard text={user.email}>
                    <Button>COPY</Button>
                  </CopyToClipboard>
                  <Button onClick={() => handleShowLocation(user)}>
                    <LocationOnIcon />
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Dialog open={openDialog} onClose={handleCloseDialog}>
        <DialogTitle>Update User Type</DialogTitle>
        <DialogContent>
          <Select
            value={selectedUserType}
            onChange={handleUserTypeChange}
            fullWidth
          >
            <MenuItem value="admin">Admin</MenuItem>
            <MenuItem value="tester">Tester</MenuItem>
            <MenuItem value="default">Default</MenuItem>
          </Select>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="primary">
            Cancel
          </Button>
          <Button onClick={handleSaveUserType} color="primary">
            Save
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={openLocationDialog} onClose={handleCloseLocationDialog}>
        <DialogTitle>Location</DialogTitle>
        <DialogContent>
          <Typography>Address: {userToShowLocation?.address}</Typography>
          <Typography>Location: {userToShowLocation?.location}</Typography>
        </DialogContent>
      </Dialog>
    </Container>
  );
};

export default UserManagement;
